<div class="main-container">
    <ng-container>
        <div class="header">
            <app-header-component></app-header-component>
        </div>
        <div class="app-container">
            <app-nav-component class="app-height"></app-nav-component>
        </div>
    </ng-container>
</div>